<script>
import { questionTypeLabel } from '@/constants/question_types';

export default {
  name: 'QuestionRow',
  props: {
    question: { type: Object, required: true },
    typesLookup: { type: Object, default: () => ({}) },
  },
  emits: ['edit', 'delete', 'toggle-required', 'toggle-visible'],
  computed: {
    typeLabel() {
      return questionTypeLabel(this.question.type, this.typesLookup) || '—';
    },

    optionsLabel() {
      const count = this.question.options?.length || 0;
      if (!count) {
        return '';
      }
      return `${count} option${count > 1 ? 's' : ''}`;
    },
  },
};
</script>

<template>
  <div class="question-row">
    <span class="question-row__label" @click="$emit('edit', question)">
      {{ question.label }}
    </span>

    <span class="question-row__type">{{ typeLabel }}</span>
    <span class="question-row__options">{{ optionsLabel }}</span>

    <label class="question-row__flag" title="Question obligatoire">
      <input
        type="checkbox"
        :checked="question.isRequired"
        @change="$emit('toggle-required', question)"
      />
      Obligatoire
    </label>

    <label class="question-row__flag" title="Visible dans l'enquête">
      <input
        type="checkbox"
        :checked="question.isVisible"
        @change="$emit('toggle-visible', question)"
      />
      Visible
    </label>

    <div class="question-row__actions">
      <button
        type="button"
        class="row-action"
        title="Modifier"
        @click="$emit('edit', question)"
      >
        <i class="ri-pencil-line"></i>
      </button>
      <button
        type="button"
        class="row-action row-action--danger"
        title="Supprimer"
        @click="$emit('delete', question)"
      >
        <i class="ri-delete-bin-line"></i>
      </button>
    </div>
  </div>
</template>
